import { C } from "./theme"

export default function TermsOfService({ onBack }) {
  const wrap = {
    minHeight: '100vh', background: C.bg, color: C.text,
    fontFamily: "'Outfit', sans-serif", padding: '24px 16px',
  }
  const container = { maxWidth: 720, margin: '0 auto' }
  const h1 = {
    fontFamily: C.serif, fontSize: 38, fontWeight: 400, letterSpacing: -0.8,
    color: C.text, marginBottom: 8,
  }
  const h2 = {
    fontFamily: C.serif, fontSize: 22, fontWeight: 400, letterSpacing: -0.3,
    color: C.text, marginTop: 32, marginBottom: 10,
  }
  const p = { fontSize: 15, lineHeight: 1.7, color: C.muted, marginBottom: 14 }
  const updated = {
    fontSize: 10, color: C.muted, marginBottom: 28,
    fontWeight: 700, letterSpacing: 1.3, textTransform: 'uppercase',
  }

  return (
    <div style={wrap}>
      <div style={container}>
        {onBack && (
          <button onClick={onBack} style={{
            background: C.glass,
            border: `1px solid ${C.glassBorder}`,
            backdropFilter: 'blur(14px) saturate(160%)',
            WebkitBackdropFilter: 'blur(14px) saturate(160%)',
            color: C.muted,
            cursor: 'pointer', fontSize: 13, fontWeight: 600, fontFamily: 'inherit',
            padding: '8px 16px', marginBottom: 24, borderRadius: 999, minHeight: 40,
          }}>
            ← Back
          </button>
        )}

        <h1 style={h1}>Terms of <span style={{ fontStyle: 'italic' }}>service</span></h1>
        <p style={updated}>Last updated: April 14, 2026</p>

        <p style={p}>
          Welcome to Settle. By accessing or using the Settle application and website (the "Service"),
          you agree to be bound by these Terms of Service ("Terms"). If you do not agree to these
          Terms, please do not use the Service.
        </p>

        <h2 style={h2}>1. Use of the Service</h2>
        <p style={p}>
          Settle provides AI-powered relocation planning tools for the Gulf Cooperation Council (GCC)
          region. The Service includes city comparison, budget planning, neighborhood recommendations,
          document guides, AI chat assistance, and related features. You must be at least 13 years old
          to use the Service.
        </p>

        <h2 style={h2}>2. Account Registration</h2>
        <p style={p}>
          To access certain features, you must create an account using a valid email address or Google
          Sign-In. You are responsible for maintaining the security of your account credentials and for
          all activities that occur under your account. You agree to notify us immediately of any
          unauthorized use.
        </p>

        <h2 style={h2}>3. AI-Generated Content</h2>
        <p style={p}>
          The Service uses artificial intelligence to generate relocation plans, budget estimates,
          neighborhood recommendations, and chat responses. While we strive for accuracy, AI-generated
          content is provided for informational purposes only and should not be relied upon as
          professional financial, legal, or immigration advice. Costs, visa requirements, and
          regulations may change without notice. Always verify critical information with official
          government sources and qualified professionals.
        </p>

        <h2 style={h2}>4. User Data and Content</h2>
        <p style={p}>
          You retain ownership of the data you enter into the Service. By using the Service, you grant
          us a limited license to store, process, and display your data as necessary to provide the
          Service to you. We handle your data in accordance with our Privacy Policy.
        </p>

        <h2 style={h2}>5. Acceptable Use</h2>
        <p style={p}>
          You agree not to use the Service to: violate any applicable laws or regulations; attempt to
          gain unauthorized access to the Service or its systems; interfere with or disrupt the
          Service; submit false or misleading information; use automated means to access the Service
          beyond normal use; or reverse-engineer, decompile, or otherwise attempt to extract the
          source code of the Service.
        </p>

        <h2 style={h2}>6. Service Availability</h2>
        <p style={p}>
          We strive to keep the Service available at all times but do not guarantee uninterrupted
          access. We may modify, suspend, or discontinue any part of the Service at any time, with or
          without notice. We are not liable for any loss or inconvenience caused by downtime or
          changes to the Service.
        </p>

        <h2 style={h2}>7. Intellectual Property</h2>
        <p style={p}>
          The Service, including its design, code, features, and content (excluding user-submitted
          data), is owned by Settle and protected by intellectual property laws. You may not copy,
          modify, distribute, or create derivative works based on the Service without our prior
          written consent.
        </p>

        <h2 style={h2}>8. Limitation of Liability</h2>
        <p style={p}>
          To the fullest extent permitted by law, Settle shall not be liable for any indirect,
          incidental, special, consequential, or punitive damages, or any loss of profits or revenue,
          arising from your use of the Service. Our total liability for any claim related to the
          Service shall not exceed the amount you paid us in the 12 months preceding the claim, or
          $100, whichever is greater.
        </p>

        <h2 style={h2}>9. Disclaimer of Warranties</h2>
        <p style={p}>
          The Service is provided "as is" and "as available" without warranties of any kind, either
          express or implied, including but not limited to warranties of merchantability, fitness for
          a particular purpose, and non-infringement. We do not warrant that the Service will be
          error-free, secure, or continuously available.
        </p>

        <h2 style={h2}>10. Termination</h2>
        <p style={p}>
          We may suspend or terminate your access to the Service at any time for violation of these
          Terms or for any other reason at our discretion. You may terminate your account at any time
          by contacting support@settletheapp.com. Upon termination, your right to use the Service
          ceases, and we may delete your data in accordance with our Privacy Policy.
        </p>

        <h2 style={h2}>11. Changes to These Terms</h2>
        <p style={p}>
          We may update these Terms from time to time. We will notify you of material changes by
          posting the updated Terms in the app. Your continued use of the Service after changes
          constitutes acceptance of the updated Terms.
        </p>

        <h2 style={h2}>12. Governing Law</h2>
        <p style={p}>
          These Terms are governed by the laws of the jurisdiction in which Settle operates, without
          regard to conflict of law provisions.
        </p>

        <h2 style={h2}>13. Contact Us</h2>
        <p style={p}>
          If you have questions about these Terms, please contact us at support@settletheapp.com.
        </p>

        <div style={{ height: 60 }} />
      </div>
    </div>
  )
}
